import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchThemeConfig, defaultThemeConfig } from '../services/ThemeApi';
import { useShopId } from './ShopIdContext';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeConfig, setThemeConfig] = useState(defaultThemeConfig);
  const [themeLoading, setThemeLoading] = useState(true);
  const [themeError, setThemeError] = useState(null);
  const { shopId } = useShopId();

  useEffect(() => {
    const loadTheme = async () => {
      try {
        setThemeLoading(true);
        const config = await fetchThemeConfig(shopId);
        setThemeConfig(config);
        setThemeError(null);
      } catch (error) {
        console.error('Error loading theme:', error);
        setThemeError(error.message);
        setThemeConfig(defaultThemeConfig);
      } finally {
        setThemeLoading(false);
      }
    };

    if (shopId) {
      loadTheme();
    }
  }, [shopId]);

  // Update meta theme-color based on landing section color1
  useEffect(() => {
    const themeColor = themeConfig?.landingSection?.color1 || defaultThemeConfig.landingSection.color1;
    const metaTag = document.querySelector('meta[name="theme-color"]');
    if (metaTag) {
      metaTag.setAttribute('content', themeColor);
    }
  }, [themeConfig]);

  const value = {
    themeConfig,
    themeLoading,
    themeError,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext;
